import React from 'react';

export default function InvoicesTable() {
	return (
		<div className="table-view table-responsive">
			<table id="invoices-table" className="table">
				<thead>
					<tr>
						<th>Invoice Number</th>
						<th>Invoice Date</th>
						<th>Due Date </th>
						<th>Payment Terms</th>
						<th>Comments</th>
						<th>Status</th>
						<th>Total</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
